<template>
  <div class="view-summary">

    <h2>AI Summary <span class="beta-badge">BETA</span></h2>
    <!-- <span class="label">Powered by Storytell.ai</span> -->

    <div v-if="hasFullTranscript" class="request-summary">
      <p>
      Skip the viewing and get a summary of this video as well as key elements.
      </p>
      <a href="#" class="cta" @click.prevent="requestSummary">
        View Summary ✨
      </a>
    </div>
    <p v-else >Once your generate a transcript, you will be able to see a summary and prompt questions about the video content.</p>

    <!-- When summary section is visible, make sure we split it with the transcription section -->
    <h2 v-if="hasFullTranscript">Full transcript</h2> 
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EventBus from '@/src/event_bus';
import track from '@/src/tracking';

export default {
  mounted: function(){
    
  },
  computed: {
    ...mapState(['item', 'transcription']),
    hasFullTranscript: function(){
      return this.transcription.id && this.transcription.attributes.status == 'done'
    },
    
  },
  methods: {
    hasStatus: function(status) {
      return this.transcription.id && this.transcription.attributes.status == status;
    },
    requestSummary: function(){
      track('summary_requested')

      const transcript = encodeURIComponent(this.transcription.attributes.transcript)

      // VERSION 1 - MVP -- Go to an external URL
      if (transcript) {
        // https://storytell.ai/report?q=
        const href = "https://storytell.ai/report?q=" + transcript + "&source=zight"
        window.open(href, '_blank');
      } else {
        this.$root.toastError('Could not find valid transcription');
      }
      
      // VERSION 2 - Prototype -- Coming soon : make and API call to get title/description and edit the content
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '@/packs/colors.scss';

  .full-width {
    text-align: center;
    padding: 0 2rem;
    color: $dark-gray;
  }
  .cta {
    display: inline-flex;
    align-items: center;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    background-color: $bright-blue;
    color: white;
    font-size: .75rem;
    text-decoration: none;
    height:min-content;
    margin:0.5rem;
  }

  .beta-badge {
      background: linear-gradient(to top, #0ba360, #3cba92);
      border-radius: 10px;
      padding: 0.063rem 0.32rem 0.125rem;
      font-size: 0.625rem;
      font-weight: 900;
      color: white;
    }
  .label {
    color: $slate-gray;
    font-size:0.7rem;
  }

  .view-summary {
    margin: 2rem 0;

    h2 {
      font-size: 1rem;
      font-weight: bold;
    }

    p {
      font-size: 1rem;
      margin: 0.875rem 0 1.75rem;
    }

  }
  .request-summary {
    display:inline-flex;
  }
</style>

<style lang="scss">
  @import "application.scss";


</style>
